import { render, staticRenderFns } from "./columnStatistics.vue?vue&type=template&id=205a6a67&scoped=true&"
import script from "./columnStatistics.vue?vue&type=script&lang=ts&"
export * from "./columnStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./columnStatistics.vue?vue&type=style&index=0&id=205a6a67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a6a67",
  null
  
)

export default component.exports